import React from 'react';
import { ToastType } from '../hooks/useToast';

interface ToastProps {
  msg: string;
  type: ToastType;
  visible: boolean;
}

const Toast: React.FC<ToastProps> = ({ msg, type, visible }) => (
  <div className={`toast${visible ? ' show' : ''} ${type !== 'default' ? type : ''}`}>
    {msg}
  </div>
);

export default Toast;
